import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CecCttFirstFitService } from './cec-ctt-first-fit.service';

@Component({
  selector: 'app-cec-ctt-first-fit',
  templateUrl: './cec-ctt-first-fit.component.html',
  styleUrls: ['./cec-ctt-first-fit.component.scss']
})
export class CecCttFirstFitComponent implements OnInit {
  selectedBtn: string = 'sales';
  selectedDi: string = 'All';
  selectedValues: any = {};
  formDetails: any = {};
  customerByTrend: any = {};
  algorithm: any = {};
  baseUrl: string = '/nrp/components/firstfit/';
  title: string = 'Customer';
  salesReal: any = {};
  marginReal: any = {};
  dailySales: any = {};
  top5: any = {};
  qParam: any = {};
  dataLoaded: boolean = false;
  reset: number = 0;
  top5Loaded = false;
  detailTiltle: string = '';
  filter: any;
  currentFilter: string = '';
  radio: any;
  lob: string = '';
  salesPercentValTop: any = {};
  salesPercentValBottom: any = {};
  marginPercentValTop: any = {};
  marginPercentValBottom: any = {};
  customerNames: any = {};

  constructor(
    private service: CecCttFirstFitService,
    private route: ActivatedRoute
  ) {
    this.route.queryParams.subscribe((params) => {
      this.filter = params['filter'];
      if (this.filter == '') {
        this.lob = 'lob_l1';
      } else {
        this.lob = 'lob';
      }
    });


  }

  private normalizeMulti(value: any): string[] {
    if (!Array.isArray(value) || value.length === 0) return ['All'];
    return value;
  }
  ngOnInit(): void {
    this.selectedValues['ctt_reported'] = ['All'];
    this.selectedValues['displacement'] = ['All'];
    this.selectedValues['certification'] = ['All'];
    this.selectedValues['internal_external'] = ['All'];
    this.selectedValues['customer_name'] = ['All'];
    this.selectedValues['lob'] = ['All'];
    this.selectedValues['product_line'] = ['All'];
    this.selectedValues['model_type'] = ['All'];
    this.selectedValues['customer_channel'] = ['All'];
    this.selectedValues['customer_group'] = ['All'];
    this.selectedValues['platform'] = ['All'];
    this.selectedValues['selling_location'] = ['All'];

    this.qParam = {
      displacement: this.normalizeMulti(this.selectedValues.displacement),
      certification: this.normalizeMulti(this.selectedValues.certification),
      customer_name: this.normalizeMulti(this.selectedValues.customer_name),
      ctt_reported: this.normalizeMulti(this.selectedValues.ctt_reported),
      lob: this.normalizeMulti(this.selectedValues.lob),
      internal_external: this.normalizeMulti(this.selectedValues.internal_external),
      product_line: this.normalizeMulti(this.selectedValues.product_line),
      model_type: this.normalizeMulti(this.selectedValues.model_type),
      customer_channel: this.normalizeMulti(this.selectedValues.customer_channel),
      customer_group: this.normalizeMulti(this.selectedValues.customer_group),
      platform: this.normalizeMulti(this.selectedValues.platform),
      selling_location: this.normalizeMulti(this.selectedValues.selling_location),
    };
    this.searchFilters();
    this.getCustomerByTrend();
    this.getAlgorithms();
    this.getSalesRealization();
  }
  searchFilters() {

    let displacement = {
      certification: this.selectedValues.certification,
      customer_name: this.selectedValues.customer_name,
      ctt_reported: this.selectedValues.ctt_reported,
      lob: this.selectedValues.lob,
      internal_external: this.selectedValues.internal_external,
      product_line: this.selectedValues.product_line,
      model_type: this.selectedValues.model_type,
      customer_channel: this.selectedValues.customer_channel,
      customer_group: this.selectedValues.customer_group,
      platform: this.selectedValues.platform,
      selling_location: this.selectedValues.selling_location,

    };
    let certification = {
      displacement: this.selectedValues.displacement,
      customer_name: this.selectedValues.customer_name,
      ctt_reported: this.selectedValues.ctt_reported,
      lob: this.selectedValues.lob,
      internal_external: this.selectedValues.internal_external,
      product_line: this.selectedValues.product_line,
      model_type: this.selectedValues.model_type,
      customer_channel: this.selectedValues.customer_channel,
      customer_group: this.selectedValues.customer_group,
      platform: this.selectedValues.platform,
      selling_location: this.selectedValues.selling_location,
      

    };
    let customer_name = {
      displacement: this.selectedValues.displacement,
      certification: this.selectedValues.certification,
      ctt_reported: this.selectedValues.ctt_reported,
      lob: this.selectedValues.lob,
      internal_external: this.selectedValues.internal_external,
      product_line: this.selectedValues.product_line,
      model_type: this.selectedValues.model_type,
      customer_channel: this.selectedValues.customer_channel,
      customer_group: this.selectedValues.customer_group,
      platform: this.selectedValues.platform,
      selling_location: this.selectedValues.selling_location,
      

    };
    let ctt_reported = {
      displacement: this.selectedValues.displacement,
      certification: this.selectedValues.certification,
      customer_name: this.selectedValues.customer_name,
      lob: this.selectedValues.lob,
      internal_external: this.selectedValues.internal_external,
      product_line: this.selectedValues.product_line,
      model_type: this.selectedValues.model_type,
      customer_channel: this.selectedValues.customer_channel,
      customer_group: this.selectedValues.customer_group,
      platform: this.selectedValues.platform,
      selling_location: this.selectedValues.selling_location,
      

    };
    let lob = {
      displacement: this.selectedValues.displacement,
      certification: this.selectedValues.certification,
      customer_name: this.selectedValues.customer_name,
      ctt_reported: this.selectedValues.ctt_reported,
      internal_external: this.selectedValues.internal_external,
      product_line: this.selectedValues.product_line,
      model_type: this.selectedValues.model_type,
      customer_channel: this.selectedValues.customer_channel,
      customer_group: this.selectedValues.customer_group,
      platform: this.selectedValues.platform,
      selling_location: this.selectedValues.selling_location,
      

    };
    let internal_external = {
      displacement: this.selectedValues.displacement,
      certification: this.selectedValues.certification,
      customer_name: this.selectedValues.customer_name,
      ctt_reported: this.selectedValues.ctt_reported,
      lob: this.selectedValues.lob,
      product_line: this.selectedValues.product_line,
      model_type: this.selectedValues.model_type,
      customer_channel: this.selectedValues.customer_channel,
      customer_group: this.selectedValues.customer_group,
      platform: this.selectedValues.platform,
      selling_location: this.selectedValues.selling_location,
      

    };
    let product_line = {
      displacement: this.selectedValues.displacement,
      certification: this.selectedValues.certification,
      customer_name: this.selectedValues.customer_name,
      ctt_reported: this.selectedValues.ctt_reported,
      lob: this.selectedValues.lob,
      internal_external: this.selectedValues.internal_external,
      model_type: this.selectedValues.model_type,
      customer_channel: this.selectedValues.customer_channel,
      customer_group: this.selectedValues.customer_group,
      platform: this.selectedValues.platform,
      selling_location: this.selectedValues.selling_location,
      

    };
    let model_type = {
      displacement: this.selectedValues.displacement,
      certification: this.selectedValues.certification,
      customer_name: this.selectedValues.customer_name,
      ctt_reported: this.selectedValues.ctt_reported,
      lob: this.selectedValues.lob,
      internal_external: this.selectedValues.internal_external,
      product_line: this.selectedValues.product_line,
      customer_channel: this.selectedValues.customer_channel,
      customer_group: this.selectedValues.customer_group,
      platform: this.selectedValues.platform,
      selling_location: this.selectedValues.selling_location,
      

    };

    let customer_channel = {
      displacement: this.selectedValues.displacement,
      certification: this.selectedValues.certification,
      customer_name: this.selectedValues.customer_name,
      ctt_reported: this.selectedValues.ctt_reported,
      lob: this.selectedValues.lob,
      internal_external: this.selectedValues.internal_external,
      product_line: this.selectedValues.product_line,
      model_type: this.selectedValues.model_type,
      customer_group: this.selectedValues.customer_group,
      platform: this.selectedValues.platform,
      selling_location: this.selectedValues.selling_location,
      
    };

    let customer_group = {
      displacement: this.selectedValues.displacement,
      certification: this.selectedValues.certification,
      customer_name: this.selectedValues.customer_name,
      ctt_reported: this.selectedValues.ctt_reported,
      lob: this.selectedValues.lob,
      internal_external: this.selectedValues.internal_external,
      product_line: this.selectedValues.product_line,
      model_type: this.selectedValues.model_type,
      customer_channel: this.selectedValues.customer_channel,
      platform: this.selectedValues.platform,
      selling_location: this.selectedValues.selling_location,
      
    };

    let platform = {
      displacement: this.selectedValues.displacement,
      certification: this.selectedValues.certification,
      customer_name: this.selectedValues.customer_name,
      ctt_reported: this.selectedValues.ctt_reported,
      lob: this.selectedValues.lob,
      internal_external: this.selectedValues.internal_external,
      product_line: this.selectedValues.product_line,
      model_type: this.selectedValues.model_type,
      customer_channel: this.selectedValues.customer_channel,
      customer_group: this.selectedValues.customer_group,
      selling_location: this.selectedValues.selling_location,
    };

    let selling_location = {
      displacement: this.selectedValues.displacement,
      certification: this.selectedValues.certification,
      customer_name: this.selectedValues.customer_name,
      ctt_reported: this.selectedValues.ctt_reported,
      lob: this.selectedValues.lob,
      internal_external: this.selectedValues.internal_external,
      product_line: this.selectedValues.product_line,
      model_type: this.selectedValues.model_type,
      customer_channel: this.selectedValues.customer_channel,
      customer_group: this.selectedValues.customer_group,
      platform: this.selectedValues.platform,
    };

    if (this.currentFilter != 'certification') {
      certification['current_dropdown'] = 'certification';
      this.getDropdowndetails(certification);
    }

    if (this.currentFilter != 'displacement') {
      displacement['current_dropdown'] = 'displacement';
      this.getDropdowndetails(displacement);
    }

    if (this.currentFilter != 'customer_name') {
      customer_name['current_dropdown'] = 'customer_name';
      this.getDropdowndetails(customer_name);
    }

    if (this.currentFilter != 'ctt_reported') {
      ctt_reported['current_dropdown'] = 'ctt_reported';
      this.getDropdowndetails(ctt_reported);
    }
    if (this.currentFilter != 'lob') {
      lob['current_dropdown'] = 'lob';
      this.getDropdowndetails(lob);
    }
    if (this.currentFilter != 'internal_external') {
      internal_external['current_dropdown'] = 'internal_external';
      this.getDropdowndetails(internal_external);
    }
    if (this.currentFilter != 'product_line') {
      product_line['current_dropdown'] = 'product_line';
      this.getDropdowndetails(product_line);
    }
    if (this.currentFilter != 'model_type') {
      model_type['current_dropdown'] = 'model_type';
      this.getDropdowndetails(model_type);
    }
    if (this.currentFilter != 'customer_channel') {
      customer_channel['current_dropdown'] = 'customer_channel';
      this.getDropdowndetails(customer_channel);
    }
    if (this.currentFilter != 'customer_group') {
      customer_group['current_dropdown'] = 'customer_group';
      this.getDropdowndetails(customer_group);
    }
    if (this.currentFilter != 'platform') {
      platform['current_dropdown'] = 'platform';
      this.getDropdowndetails(platform);
    }
    if (this.currentFilter != 'selling_location') {
      selling_location['current_dropdown'] = 'selling_location';
      this.getDropdowndetails(selling_location);
    }
  }
  getDropdowndetails(type) {
    this.service
      .getDropDown(type, this.baseUrl + 'dropdown')
      .subscribe((results) => {
        let channel: any[] = [];

        if (type.current_dropdown == 'certification')
          channel = results.certification;
        if (type.current_dropdown == 'displacement')
          channel = results.displacement;
        if (type.current_dropdown == 'customer_name')
          channel = results.customer_name;

        if (type.current_dropdown == 'internal_external') channel = results.internal_external;

        if (type.current_dropdown == 'ctt_reported')
          channel = results.ctt_reported;
        if (type.current_dropdown == 'lob') channel = results.lob;
        if (type.current_dropdown == 'product_line')
          channel = results.product_line;
        if (type.current_dropdown == 'model_type')
          channel = results.model_type;
        if (type.current_dropdown == 'customer_channel')
          channel = results.customer_channel;
        if (type.current_dropdown == 'customer_group')
          channel = results.customer_group;
        if (type.current_dropdown == 'platform')
          channel = results.platform;
        if (type.current_dropdown == 'selling_location')
          channel = results.selling_location;
        const resp = [...new Set(channel)];

        if (type.current_dropdown == 'displacement') {
          this.formDetails['displacement'] =
            resp && resp.map((i: string) => ({ viewValue: i, value: i }));
        }
        if (type.current_dropdown == 'certification') {
          this.formDetails['certification'] =
            resp && resp.map((i: string) => ({ viewValue: i, value: i }));
        }
        if (type.current_dropdown == 'ctt_reported') {
          this.formDetails['ctt_reported'] =
            resp && resp.map((i: string) => ({ viewValue: i, value: i }));
        }
        if (type.current_dropdown == 'customer_name') {
          this.formDetails['customer_name'] =
            resp && resp.map((i: string) => ({ viewValue: i, value: i }));
        }
        if (type.current_dropdown == 'internal_external') {
          this.formDetails['internal_external'] =
            resp && resp.map((i: string) => ({ viewValue: i, value: i }));
        }
        if (type.current_dropdown == 'lob')
          this.formDetails['lob'] =
            resp && resp.map((i: string) => ({ viewValue: i, value: i }));

        if (type.current_dropdown == 'product_line')
          this.formDetails['product_line'] =
            resp && resp.map((i: string) => ({ viewValue: i, value: i }));
        if (type.current_dropdown == 'model_type')
          this.formDetails['model_type'] =
            resp && resp.map((i: string) => ({ viewValue: i, value: i }));
        if (type.current_dropdown == 'customer_channel')
          this.formDetails['customer_channel'] =
            resp && resp.map((i: string) => ({ viewValue: i, value: i }));
        if (type.current_dropdown == 'customer_group')
          this.formDetails['customer_group'] =
            resp && resp.map((i: string) => ({ viewValue: i, value: i }));
        if (type.current_dropdown == 'platform')
          this.formDetails['platform'] =
            resp && resp.map((i: string) => ({ viewValue: i, value: i }));
        if (type.current_dropdown == 'selling_location')
          this.formDetails['selling_location'] =
            resp && resp.map((i: string) => ({ viewValue: i, value: i }));

        this.formDetails = { ...this.formDetails };
      });
  }
  searchSalesData(event) {
    this.dataLoaded = false;
    this.currentFilter = event.type;
    this.selectedValues[event.type] = event.value;
    this.qParam[event.type] = event.value;
    this.qParam = {
      displacement: this.normalizeMulti(this.selectedValues.displacement),
      certification: this.normalizeMulti(this.selectedValues.certification),
      customer_name: this.normalizeMulti(this.selectedValues.customer_name),
      ctt_reported: this.normalizeMulti(this.selectedValues.ctt_reported),
      lob: this.normalizeMulti(this.selectedValues.lob),
      internal_external: this.normalizeMulti(this.selectedValues.internal_external),
      product_line: this.normalizeMulti(this.selectedValues.product_line),
      model_type: this.normalizeMulti(this.selectedValues.model_type),
      customer_channel: this.normalizeMulti(this.selectedValues.customer_channel),
      customer_group: this.normalizeMulti(this.selectedValues.customer_group),
      platform: this.normalizeMulti(this.selectedValues.platform),
      selling_location: this.normalizeMulti(this.selectedValues.selling_location),
          };

    this.searchFilters();
    this.getCustomerByTrend();
    if (this.selectedBtn == 'sales') {
      this.getSalesRealization();

    } else if (this.selectedBtn == 'margin') {
      this.getMarginRealization();
    }
    this.getAlgorithms();

    if (this.selectedDi !== 'All') {
      this.searchDimension(this.selectedDi);
    }
  }
  getAlgorithms() {
    this.dataLoaded = false;
    this.service
      .getAlgorithmsValues(this.qParam, this.baseUrl + 'algorithm')
      .subscribe((results) => {
        this.algorithm = results;
        this.dataLoaded = true;
      });
  }
  getCustomerByTrend() {
    this.customerByTrend = [];
    this.top5Loaded = false;
    // this.customerNames = { customer_name: this.selectedValues.customer_name };
    this.service
      .getCustomerByTrendBridgeValues(this.qParam, this.baseUrl + 'customertrend')
      .subscribe((results) => {
        this.customerByTrend = results;
        this.top5Loaded = true;
      });
  }
  getSalesRealization() {
    this.salesReal = [];
    this.dataLoaded = false;

    this.service
      .getSalesBridgeValues(this.qParam, this.baseUrl + 'salesrealisation')

      .subscribe((results) => {
        this.salesReal = results;
        this.dataLoaded = true;
      });

    // this.service.getSalesPercentageVal(this.qParam, this.baseUrl + 'salesrealisation/percentage/top').subscribe((res) => {
    //   this.salesPercentValTop = res;
    //   this.dataLoaded = true;
    // })
    // this.service.getSalesPercentageVal(this.qParam, this.baseUrl + 'salesrealisation/percentage').subscribe((res) => {
    //   this.salesPercentValBottom = res;
    //   this.dataLoaded = true;
    // })

  }


  getMarginRealization() {
    this.marginReal = [];
    this.dataLoaded = false;
    this.service.getMarginBrigeValues(this.qParam, this.baseUrl + 'marginrealisation')
      .subscribe((results) => {
        this.marginReal = results;
        this.dataLoaded = true;
      });

    // this.service.getMarginPercentValues(this.qParam, this.baseUrl + 'marginrealisation/percentage/top')
    //   .subscribe((responese) => {
    //     this.marginPercentValTop = responese;
    //     this.dataLoaded = true;
    //   })
    // this.service.getMarginPercentValues(this.qParam, this.baseUrl + 'marginrealisation/percentage')
    //   .subscribe((responese) => {
    //     this.marginPercentValBottom = responese;
    //     this.dataLoaded = true;
    //   })
  }

  salesButton() {
    this.selectedBtn = 'sales';
    this.getSalesRealization();

  }
  marginButton() {
    this.selectedBtn = 'margin';
    this.getMarginRealization();
  }

  byTrend() {
    this.selectedDi = 'All';
    this.qParam.lob = ['All'];
    this.getCustomerByTrend();
    if (this.selectedBtn == 'sales') {
      this.getSalesRealization();

    } else if (this.selectedBtn == 'margin') {
      this.getMarginRealization();
    }
    this.radio = null;
  }
  searchDimension(event) {
    this.qParam = {
      displacement: this.normalizeMulti(this.selectedValues.displacement),
      certification: this.normalizeMulti(this.selectedValues.certification),
      customer_name: this.normalizeMulti(this.selectedValues.customer_name),
      ctt_reported: this.normalizeMulti(this.selectedValues.ctt_reported),
      lob: this.normalizeMulti(this.selectedValues.lob),
      internal_external: this.normalizeMulti(this.selectedValues.internal_external),
      product_line: this.normalizeMulti(this.selectedValues.product_line),
      model_type: this.normalizeMulti(this.selectedValues.model_type),
      customer_channel: this.normalizeMulti(this.selectedValues.customer_channel),
      customer_group: this.normalizeMulti(this.selectedValues.customer_group),
      platform: this.normalizeMulti(this.selectedValues.platform),
      selling_location: this.normalizeMulti(this.selectedValues.selling_location),
          };
    this.selectedDi = event;
    this.top5Loaded = false;

    this.top5 = [];
    this.service
      .getTop5Values(this.qParam, this.baseUrl + 'sales/top5/' + event)
      .subscribe((results) => {
        this.top5 = results;
        this.top5Loaded = true;
      });
  }

  resetFilter() {
    this.reset = this.reset + 1;
    this.qParam = {
      displacement: ['All'],
      certification: ['All'],
      customer_name: ['All'],
      ctt_reported: ['All'],
      lob: ['All'],
      internal_external: ['All'],
      model_type: ['All'],
      customer_channel: ['All'],
      customer_group: ['All'],
      platform: ['All'],
      selling_location: ['All'],
      product_line: ['All'],
    };
    this.selectedValues['ctt_reported'] = ['All'];
    this.selectedValues['displacement'] = ['All'];
    this.selectedValues['certification'] = ['All'];
    this.selectedValues['internal_external'] = ['All'];
    this.selectedValues['customer_name'] = ['All'];
    this.selectedValues['lob'] = ['All'];
    this.selectedValues['product_line'] = ['All'];
    this.selectedValues['model_type'] = ['All'];
    this.selectedValues['customer_channel'] = ['All'];
    this.selectedValues['customer_group'] = ['All'];
    this.selectedValues['platform'] = ['All'];
    this.selectedValues['selling_location'] = ['All'];

    this.currentFilter = '';
    this.searchFilters();
    this.byTrend();
    this.getAlgorithms();
  }
  legendClick(event) {
    
    this.qParam.lob = [event];
      if (this.selectedBtn == 'sales') {
        this.getSalesRealization();
      }
      if (this.selectedBtn == 'margin') {
        this.getMarginRealization();
      }

      this.getAlgorithms();
    
  }

}
